import { request } from '@/shared/api/request'

export const getPosition = (params) => {
	return request({ url: 'dict/position/findOne', method: 'GET', params })
}
